import styled from 'styled-components';
import { IconSize } from '../../lib';
import { defaultMuiTheme } from '../../styles/MaterialTheme';
import { BackgroundImage } from '../Image';
export const MarketplaceContentContainer = styled.div `
    padding-left: 1.5rem;
    padding-right: 1.5rem;
    max-width: 940px;
    width: 100%;
    flex-grow: 1;
`;
export const Title = styled.div `
    font-size: 34px;
    line-height: 40px;
    color: ${({ theme }) => theme.colors.text};
    font-size: 34px;
    font-weight: 500;
    letter-spacing: 0.07px;
    line-height: 39.78px;
    text-align: center;
    margin-top: 4rem;
    margin-bottom: 4rem;
`;
export const TenantCardContainer = styled.div `
    box-sizing: border-box;
    min-height: auto;
    width: 100%;
    max-height: 100%;
    border: 1px solid ${({ theme }) => theme.colors.border};
    border-radius: 6px;
    background-color: ${({ theme }) => theme.colors.surface};
    margin-bottom: 1.5rem;
    display: flex;
    flex-direction: column;
    padding-right: 1.5rem;
    cursor: pointer;
    ${defaultMuiTheme.breakpoints.down(600)} {
        padding-left: 1.5rem;
    }
`;
export const TenantDetails = styled.div `
    display: flex;
    flex-direction: column;
    padding-left: 158px;
    margin-top: -50px;
    ${defaultMuiTheme.breakpoints.down(600)} {
        padding-left: 0rem;
        margin-top: 0;
    }
`;
export const TenantTitle = styled.div `
    color: ${({ theme }) => theme.colors.text};
    font-size: 24px;
    font-weight: 500;
    letter-spacing: 0.05px;
    line-height: 36px;
    margin-top: 1.5rem;
`;
export const TenantSubTitle = styled.div `
    color: ${({ theme }) => theme.colors.textSecondary};
    font-size: 14.22px;
    letter-spacing: 0.1px;
    line-height: 20px;
    margin-bottom: 0.5rem;
`;
export const ImageContainer = styled.div `
    width: 125px;
    height: 125px;
    margin: 1rem;
    ${defaultMuiTheme.breakpoints.down(600)} {
        margin-right: 1rem;
        margin-left: 0.5rem;
        width: 56px;
        height: 56px;
    }
`;
export const StyledImage = styled(BackgroundImage.Large) `
    border-radius: 50%;
`;
export const Description = styled.div `
    width: 100%;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    color: ${({ theme }) => theme.colors.textSecondary};
    font-size: 1rem;
    letter-spacing: 0.09px;

    line-height: 1.5rem;

    ${defaultMuiTheme.breakpoints.down(600)} {
        -webkit-line-clamp: 4;
    }
`;
export const StatsContainer = styled.div `
    display: flex;
    align-content: center;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-top: 1.5rem;
    margin-bottom: 1.5rem;
`;
export const MarketHeader = styled.div `
    padding-top: 2.5rem;
    padding-bottom: 1.5rem;
    width: 100%;
    margin-bottom: 1.5rem;

    display: flex;
    align-items: center;
    background-color: ${({ theme }) => theme.colors.surface};
    border-bottom: 1px solid ${({ theme }) => theme.colors.border};
    ${defaultMuiTheme.breakpoints.down(600)} {
        padding: 0.5rem 0 0.5rem 0.5rem;
    }
`;
export const MarketBorder = styled.div `
    max-width: 940px;
    padding-left: 1.5rem;
    margin: 0 auto;
    width: 100%;
    display: flex;
    align-items: center;
`;
export const MarketTitleContainer = styled.div `
    display: flex;
    flex-direction: column;
`;
export const MarketIconContainer = styled.div `
    display: flex;
    width: 6rem;
    height: 6rem;
    margin-right: 1.5rem;
    border: 1px solid ${({ theme }) => theme.colors.border};
    border-radius: 50%;
    justify-content: center;
    ${defaultMuiTheme.breakpoints.down(600)} {
        width: 4rem;
        height: 4rem;
    }
    flex-shrink: 0;
    svg {
        width: ${IconSize.ExtraLarge};
        color: ${({ theme }) => theme.colors.primary};
        ${defaultMuiTheme.breakpoints.down(600)} {
            ${IconSize.Medium};
        }
    }
`;
export const MarketTextOverLine = styled.div `
    font-weight: 300;
    font-size: 1.5rem;
    color: ${({ theme }) => theme.colors.textSecondary};
    line-height: 36px;
    ${defaultMuiTheme.breakpoints.down(600)} {
        font-size: 1rem;
        line-height: 1.5rem;
    }
    ${defaultMuiTheme.breakpoints.down(400)} {
        font-size: ${({ theme }) => theme.fonts.textSizeStandard};
        line-height: 1rem;
    }
`;
export const MarketTitle = styled.div `
    font-size: ${({ theme }) => theme.fonts.textSizeXXL};
    font-weight: 500;
    line-height: 60px;
    color: ${({ theme }) => theme.colors.text};

    ${defaultMuiTheme.breakpoints.down(600)} {
        font-size: ${({ theme }) => theme.fonts.textSizeXL};
        line-height: 52px;
    }
    ${defaultMuiTheme.breakpoints.down(400)} {
        font-size: ${({ theme }) => theme.fonts.textSizeH2};
        line-height: 34px;
    }
`;
//# sourceMappingURL=styles.js.map